import { ChangeDetectorRef, ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class ErrorBoundaryService {
  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    private readonly errorHandler: ErrorHandler,
  ) {
    this.changeDetector.detach();
  }

  ngDoCheck(): any | undefined {
    try {
      this.changeDetector.detectChanges();
    } catch (e) {
      this.errorHandler.handleError(e);
      return e;
    }
  }
}
